import "./industries.css";
import SEO from "../../SEO";

/* ── SVG Icons ──────────────────────────────────────────────────────────── */
const MonitorIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="2" y="3" width="20" height="14" rx="2" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <line x1="12" y1="17" x2="12" y2="21" />
  </svg>
);

const LMSIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
  </svg>
);

const AITutorIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    <line x1="9" y1="10" x2="15" y2="10" />
    <line x1="12" y1="7" x2="12" y2="13" />
  </svg>
);

const ExamIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <polyline points="9 15 11 17 15 13" />
  </svg>
);

const AnalyticsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
    <line x1="2" y1="20" x2="22" y2="20" />
  </svg>
);

const PersonIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const ZapIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);

const CloudIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
  </svg>
);

const CheckIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const ArrowIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

/* ── Data ───────────────────────────────────────────────────────────────── */
const solutions = [
  {
    icon: <MonitorIcon />,
    title: "E-Learning Platforms",
    desc: "Feature-rich online learning portals with video lessons, interactive quizzes, progress tracking, and certificate generation built for scale.",
  },
  {
    icon: <LMSIcon />,
    title: "Learning Management Systems",
    desc: "End-to-end LMS covering course authoring, enrolment management, instructor dashboards, grading, and learner analytics in one platform.",
  },
  {
    icon: <AITutorIcon />,
    title: "AI-Based Tutoring Systems",
    desc: "Conversational AI tutors that adapt explanations to each student's pace, identify knowledge gaps, and provide personalised practice paths.",
  },
  {
    icon: <ExamIcon />,
    title: "Online Exam & Assessment Platforms",
    desc: "Secure proctored exam platforms with auto-grading, randomised question banks, plagiarism detection, and real-time results dashboards.",
  },
  {
    icon: <AnalyticsIcon />,
    title: "Student Performance Analytics",
    desc: "Data dashboards that surface learning velocity, engagement scores, at-risk flags, and cohort-level trends to help educators act fast.",
  },
];

const projects = [
  {
    icon: <AITutorIcon />,
    tag: "AI · Learning",
    accent: "edu-project-card--teal",
    title: "AI Learning Platform",
    desc: "A personalised learning platform that builds adaptive study paths for each student based on their quiz performance, learning velocity, and knowledge gaps.",
    features: [
      "Adaptive learning path generation",
      "AI-driven content recommendations",
      "Real-time knowledge gap detection",
    ],
  },
  {
    icon: <ExamIcon />,
    tag: "Assessment · Exams",
    accent: "edu-project-card--indigo",
    title: "Online Exam System",
    desc: "A secure, auto-evaluated online examination platform with randomised question sets, live proctoring, instant grading, and detailed result analytics.",
    features: [
      "Auto-evaluation with instant results",
      "Randomised question bank engine",
      "AI-assisted live proctoring",
    ],
  },
  {
    icon: <AnalyticsIcon />,
    tag: "Analytics · Dashboard",
    accent: "edu-project-card--violet",
    title: "Student Analytics Dashboard",
    desc: "A data intelligence platform for educators — tracking individual performance, engagement trends, completion rates, and cohort-level learning outcomes.",
    features: [
      "Per-student performance heatmaps",
      "Engagement & completion tracking",
      "At-risk student early-warning system",
    ],
  },
];

const benefits = [
  {
    icon: <PersonIcon />,
    title: "Personalised Learning Experience",
    desc: "AI-driven content adapts to every learner's pace, style, and gaps — delivering outcomes that one-size-fits-all curricula simply cannot match.",
  },
  {
    icon: <CloudIcon />,
    title: "Scalable Education Platforms",
    desc: "Cloud-native architecture serves 10 or 10 million learners without degradation — built to grow with your institution from day one.",
  },
  {
    icon: <ZapIcon />,
    title: "Improved Student Engagement",
    desc: "Gamification, interactive content, live sessions, and instant feedback loops keep learners motivated and on-course through every module.",
  },
  {
    icon: <AnalyticsIcon />,
    title: "Data-Driven Insights",
    desc: "Comprehensive dashboards turn learning data into actionable intelligence — helping institutions improve curriculum, reduce drop-off, and track outcomes.",
  },
];

/* ── Component ──────────────────────────────────────────────────────────── */
export default function Education() {
  return (
    <>
      <SEO
        title="EdTech: E-Learning & AI Learning Platforms | Best Code Technology"
        description="Build modern e-learning platforms and AI-based education systems."
        keywords="edtech, e-learning platform, AI education"
        url="https://bestcodetechnology.in/industries/education"
      />

      <div className="ind-page ind-page--education">
        {/* ════════════════════════════════════════════════════════════════════
          HERO — light bg, split: left content + right image placeholder
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="edu-hero">
          <div className="container-xl">
            <div className="row align-items-center g-5">
              {/* Left */}
              <div className="col-12 col-lg-6">
                <div className="edu-hero__eyebrow">
                  <span className="edu-pill">Education Industry</span>
                </div>

                <h1 className="edu-hero__headline">
                  Digital Learning Platforms
                  <span> Powered by AI</span>
                </h1>

                <p className="edu-hero__desc">
                  We build modern education platforms that enhance learning
                  experiences through personalisation and automation — for
                  schools, universities, and edtech startups.
                </p>

                <div className="edu-hero__actions">
                  <a href="#solutions" className="edu-btn-primary">
                    Explore Solutions
                    <ArrowIcon />
                  </a>
                  <a href="#projects" className="edu-btn-outline">
                    See What We Build
                  </a>
                </div>

                {/* Stats */}
                <div className="edu-hero__stats">
                  <div className="edu-hero-stat">
                    <strong>AI-Powered</strong>
                    <span>Personalisation</span>
                  </div>
                  <div className="edu-stat-sep" aria-hidden="true" />
                  <div className="edu-hero-stat">
                    <strong>99.9%</strong>
                    <span>Platform Uptime</span>
                  </div>
                  <div className="edu-stat-sep" aria-hidden="true" />
                  <div className="edu-hero-stat">
                    <strong>Mobile-First</strong>
                    <span>Offline Support</span>
                  </div>
                </div>
              </div>

              {/* Right: live learning dashboard */}
              <div className="col-12 col-lg-6">
                <div className="edu-hero__visual">
                  <div className="edu-dashboard">
                    <div className="edu-dashboard__head">
                      <span className="edu-dashboard__title">
                        <span className="edu-dashboard__dot" aria-hidden="true" />
                        Learning Dashboard
                      </span>
                      <span className="edu-dashboard__live">LIVE</span>
                    </div>

                    <div className="edu-metrics">
                      <div className="edu-metric">
                        <span className="edu-metric__value">Adaptive</span>
                        <span className="edu-metric__label">Learning Paths</span>
                      </div>
                      <div className="edu-metric">
                        <span className="edu-metric__value">Auto</span>
                        <span className="edu-metric__label">Assessment</span>
                      </div>
                      <div className="edu-metric">
                        <span className="edu-metric__value">Live</span>
                        <span className="edu-metric__label">Progress</span>
                      </div>
                    </div>

                    <div className="edu-chart">
                      <div className="edu-chart__head">
                        <span className="edu-chart__label">
                          Course Completion — This Term
                        </span>
                      </div>
                      <div className="edu-bars" aria-hidden="true">
                        {[52, 68, 44, 81, 60, 92, 74, 86].map((h, i) => (
                          <span
                            key={i}
                            className="edu-bar"
                            style={{ "--bar-h": `${h}%` }}
                          />
                        ))}
                      </div>
                    </div>

                    <div className="edu-feed">
                      <span className="edu-feed__icon" aria-hidden="true">
                        <CheckIcon />
                      </span>
                      <span className="edu-feed__body">
                        <span className="edu-feed__title">
                          Module 4 — Quiz auto-graded
                        </span>
                        <span className="edu-feed__meta">
                          128 submissions · results published
                        </span>
                      </span>
                    </div>

                    <div className="edu-feed">
                      <span className="edu-feed__icon" aria-hidden="true">
                        <AITutorIcon />
                      </span>
                      <span className="edu-feed__body">
                        <span className="edu-feed__title">
                          AI tutor flagged 6 learners
                        </span>
                        <span className="edu-feed__meta">
                          Knowledge gap · Algebra II
                        </span>
                      </span>
                    </div>

                    <div className="edu-feed">
                      <span className="edu-feed__icon" aria-hidden="true">
                        <AnalyticsIcon />
                      </span>
                      <span className="edu-feed__body">
                        <span className="edu-feed__title">
                          Cohort report generated
                        </span>
                        <span className="edu-feed__meta">
                          Engagement · completion · at-risk
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ════════════════════════════════════════════════════════════════════
          SOLUTIONS — 3+2 gradient icon cards
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="edu-solutions" id="solutions">
          <div className="container-xl">
            <div className="row justify-content-center mb-4 mb-lg-5">
              <div className="col-12 col-md-10 col-lg-7 text-center">
                <span className="edu-pill edu-pill--subtle">Key Solutions</span>
                <h2 className="edu-section-title mt-3">
                  Education Systems Built for Every Learner
                </h2>
                <p className="edu-section-sub">
                  Five specialised platforms covering every layer of modern
                  digital education — from content delivery to AI-driven
                  outcomes intelligence.
                </p>
              </div>
            </div>

            <div className="row g-4">
              {solutions.map((item, i) => (
                <div
                  key={i}
                  className={`col-12 col-md-6 ${i < 3 ? "col-lg-4" : "col-lg-6"}`}
                >
                  <div className="edu-sol-card">
                    <div className="edu-sol-card__top">
                      <div className="edu-sol-card__icon-wrap">{item.icon}</div>
                      {/* */}
                    </div>
                    <h4 className="edu-sol-card__title">{item.title}</h4>
                    <p className="edu-sol-card__desc">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ════════════════════════════════════════════════════════════════════
          TECHNOLOGIES — full-row feature blocks
      ═══════════════════════════════════════════════════════════════════════ */}

        {/* ════════════════════════════════════════════════════════════════════
          PROJECTS — accent-bordered showcase cards (dark bg)
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="edu-projects" id="projects">
          <div className="container-xl">
            <div className="row justify-content-center mb-4 mb-lg-5">
              <div className="col-12 col-md-10 col-lg-7 text-center">
                <span className="edu-pill edu-pill--dark">Platform Capabilities</span>
                <h2 className="edu-section-title edu-section-title--light mt-3">
                  What We Build for Education
                </h2>
                <p className="edu-section-sub edu-section-sub--light">
                  Three platform builds we take on for education teams — spanning
                  AI learning, assessments, and analytics.
                </p>
              </div>
            </div>

            <div className="row g-4">
              {projects.map((project, i) => (
                <div key={i} className="col-12 col-lg-4">
                  <div className={`edu-project-card ${project.accent}`}>
                    <div className="edu-project-card__header">
                      <div className="edu-project-card__icon">
                        {project.icon}
                      </div>
                      {/* */}
                    </div>
                    <span className="edu-project-card__tag">{project.tag}</span>
                    <h3 className="edu-project-card__title">{project.title}</h3>
                    <p className="edu-project-card__desc">{project.desc}</p>
                    <ul className="edu-project-card__features">
                      {project.features.map((feat, fi) => (
                        <li key={fi}>
                          <CheckIcon />
                          <span>{feat}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ════════════════════════════════════════════════════════════════════
          BENEFITS — light bg, 2×2 numbered benefit cards
      ═══════════════════════════════════════════════════════════════════════ */}
        <section className="edu-benefits">
          <div className="container-xl">
            <div className="row justify-content-center mb-4 mb-lg-5">
              <div className="col-12 col-md-10 col-lg-7 text-center">
                <span className="edu-pill edu-pill--subtle">Why BCT</span>
                <h2 className="edu-section-title mt-3">
                  The Advantage of Building with BCT
                </h2>
                <p className="edu-section-sub">
                  From AI-powered personalisation to mobile-first delivery,
                  every platform we build is designed to improve learning
                  outcomes at every scale.
                </p>
              </div>
            </div>

            <div className="row g-4">
              {benefits.map((b, i) => (
                <div key={i} className="col-12 col-sm-6">
                  <div className="edu-benefit-card">
                    <div className="edu-benefit-card__top">
                      <div className="edu-benefit-card__icon">{b.icon}</div>
                    </div>
                    <h4 className="edu-benefit-card__title">{b.title}</h4>
                    <p className="edu-benefit-card__desc">{b.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Bottom CTA strip */}
            <div className="edu-cta-strip">
              <div className="row align-items-center">
                <div className="col-12 col-lg-8">
                  <h3 className="edu-cta-strip__title">
                    Ready to transform your education platform?
                  </h3>
                  <p className="edu-cta-strip__sub">
                    Let's build a learning experience your students will love.
                  </p>
                </div>
                <div className="col-12 col-lg-4 text-lg-end">
                  <a
                    href="/services/ai-applications"
                    className="edu-btn-primary"
                  >
                    Start a Project
                    <ArrowIcon />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
